import { render, staticRenderFns } from "./AgendeListComponent.vue?vue&type=template&id=15e6c882"
import script from "./AgendeListComponent.vue?vue&type=script&lang=js"
export * from "./AgendeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports